import { type ExamCenterProctorRequestStep } from '@exam-center/graphql';
import { Navigate } from '@exam-center/router';
import { type PropsWithChildren } from '@shared/utils';

import { useGetReviewerPermissionByStep } from '../../hooks';

interface AdminProctorRequestReviewerPermissionGuardProps extends PropsWithChildren {
  currentStep: ExamCenterProctorRequestStep;
}

export default function AdminProctorRequestReviewerPermissionGuard(
  props: Readonly<AdminProctorRequestReviewerPermissionGuardProps>,
) {
  const { children, currentStep } = props;

  const { hasViewAccess } = useGetReviewerPermissionByStep(currentStep);

  if (!hasViewAccess) {
    return <Navigate to='/access-denied' />;
  }

  return children;
}
